import { useSoundPath } from 'hooks/useSoundPath';
import { createContext, useContext, useRef } from 'react';

const SliderContext = createContext();

export const SliderProvider = ({ children }) => {
  const swiperRef = useRef(null);
  const playSound = useSoundPath();

  const slideNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
      playSound('main');
    }
  };

  const slidePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
      playSound('main');
    }
  };

  return (
    <SliderContext.Provider value={{ swiperRef, slideNext, slidePrev }}>
      {children}
    </SliderContext.Provider>
  );
};

export const useSlider = () => {
  return useContext(SliderContext);
};
